import * as React from "react"
import type { SVGProps } from "react"
const SvgHomeFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 19v-9a2 2 0 0 1 .8-1.6l6-4.5q.53-.4 1.2-.4t1.2.4l6 4.5q.38.28.59.7t.21.9v9q0 .83-.59 1.41-.59.6-1.41.59h-3a1 1 0 0 1-.71-.29A1 1 0 0 1 14 20v-5q0-.42-.29-.71A1 1 0 0 0 13 14h-2q-.42 0-.71.29-.3.29-.29.71v5q0 .42-.29.71-.29.3-.71.29H6q-.82 0-1.41-.59-.6-.59-.59-1.41" />
  </svg>
)
export default SvgHomeFilled
